export default __webpack_public_path__ + "static/B0114-d8bb12b5f7b1e9db17d648670add4512.png";